import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Venue from "../components/venue"
import Arrivare from "../components/arrivare"
import Accomodation from "../components/accomodation"
import Newsletter from "../components/newsletter"
import Banner from "../components/banner"


const InfoPage = ({pageContext: {locale}}) => (
  <Layout locale={locale}>
    <SEO title="info" />
    <div className="event-wrapper">
      <Venue/>
      <Arrivare/>
      <Accomodation/>
      <Newsletter/>
      <Banner/>
    </div>
  </Layout>
);

export default InfoPage;
